import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import type { CaraWorkspaceFieldsFragment } from '~/api/graphql';

type Artifact = CaraWorkspaceFieldsFragment['artifacts'][0];

/**
 * Moves a `?artifact_id=&version=` link onto a version a change on the page created, such as a
 * design switch. useUrlArtifactSync opens the version the link names on every workspace update,
 * so a link left on the old version would take the new one away again.
 */
export const useFollowCreatedVersion = () => {
  const location = useLocation();
  const navigate = useNavigate();
  return React.useCallback(
    (created: Artifact) => {
      const params = new URLSearchParams(location.search);
      if (params.get('artifact_id') !== created.id) return;
      if (params.get('version') === String(created.version)) return;
      params.set('version', String(created.version));
      navigate({ pathname: location.pathname, search: `?${params.toString()}` }, { replace: true });
    },
    [location.pathname, location.search, navigate]
  );
};
